// src/components/WhatsAppButton.jsx
import { FaWhatsapp } from "react-icons/fa";

export default function WhatsAppButton() {
  const message = "Hello, I would like to know more about your products!";

  return (
    <a
      href={`https://wa.me/${process.env.REACT_APP_PHONE}?text=${encodeURIComponent(message)}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed z-50 flex items-center justify-center right-4 sm:right-6 bottom-4 sm:bottom-6"
    >
      {/* Outer pulse ring */}
      <span className="absolute w-14 h-14 rounded-full bg-[#25d366]/35 animate-ping" />

      {/* Main circular button */}
      <span className="relative flex items-center justify-center w-14 h-14 bg-[#25d366] hover:bg-[#20bd5a] text-white rounded-full shadow-lg transition-all duration-300">
        <FaWhatsapp className="w-7 h-7" />
      </span>
    </a>
  );
}
